module.exports = __webpack_public_path__ + "static/zamioculcas-zamiifolia-cb819ceee23a19090f369d5dff019f50.svg";